// extracted by mini-css-extract-plugin
module.exports = {"spin":"BESSDashboard_spin__oKSUH"};